
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';

const JoinButton = ({
   settings,
}) => {
   if(!settings.enabled) return null;
   return (
      <div className='h-11 inline-flex'>
         <Button
            classNames='h-full'
            text={ settings?.text }
            padding='0 py-2 px-5'
            textMarginX='large'
            fontWeight='semibold'
            borderRadius='label'
            primaryColor
         />
      </div>
   )

}
JoinButton.propTypes = {
   settings: PropTypes.object,
};

export default JoinButton;


